import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addSwiper from "./components/addSwiper";
export default {
  name: "topBanner",
  mixins: [loadMoreList, serchSelect],
  components: {
    addSwiper: addSwiper
  },
  data: function data() {
    return {
      pagingReqFn: "bannerData",
      pagingReqValue: "",
      tableBody: 'topBannerTable',
      sortReq: 'bannerChangeSort'
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'bannerDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};